import { render, staticRenderFns } from "./DocumentCategory.vue?vue&type=template&id=355be07b"
import script from "./DocumentCategory.vue?vue&type=script&lang=js"
export * from "./DocumentCategory.vue?vue&type=script&lang=js"
import style0 from "./DocumentCategory.vue?vue&type=style&index=0&id=355be07b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355be07b')) {
      api.createRecord('355be07b', component.options)
    } else {
      api.reload('355be07b', component.options)
    }
    module.hot.accept("./DocumentCategory.vue?vue&type=template&id=355be07b", function () {
      api.rerender('355be07b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/DocumentCategory.vue"
export default component.exports